module.exports = __webpack_public_path__ + "img/image-placeholder.294de88d.jpg";